// @flow
import Button from './Button';

export { ButtonColors } from './Button';
export type { ButtonColor, ButtonProps } from './Button';

export default Button;
